
import { get } from '@/utils/request'
export default {
  namespaced: true,
  state: {
  },
  getters: {

  },
  mutations: {

  },
  actions: {
    //  时间筛选
    async getSiftTimeListByClassTask(context, params) {
      const res = await get('/Study/classStudyTask/getSiftTimeListByClassTask', params)
      return res
    },
    //  时间筛选
    async getStudentErrorQuestion(context, params) {
      const res = await get('/Study/classStudyTask/getClsErrorShitiByStudent', params)
      return res
    }

  }
}

